import React, { useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CustomCursor from "./motion/CustomCursor";

const skipMotion = () =>
  typeof window !== "undefined" &&
  (navigator.webdriver ||
    window.matchMedia("(prefers-reduced-motion: reduce)").matches);

/**
 * Shared shell for all human-facing pages: dark void background, grain
 * overlay, navbar, footer and a GSAP transition on every route change.
 * Puppeteer render targets (/getprofile/:id, /:id/rankcard, /top) are
 * intentionally NOT wrapped in this layout.
 */
const Layout = () => {
  const main = useRef(null);
  const location = useLocation();

  useGSAP(() => {
    if (skipMotion()) return;
    gsap.fromTo(
      main.current,
      { opacity: 0, y: 24 },
      { opacity: 1, y: 0, duration: 0.6, ease: "power3.out" }
    );
  }, { dependencies: [location.pathname] });

  return (
    <div className="grain min-h-screen bg-void text-white flex flex-col">
      <CustomCursor />
      <Navbar />
      <main ref={main} className="flex-grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
